import styles from '@styles/screens/StartDemoScreen.module.css'
import { HorizontalContainer, VerticalContainer, VerticalSpacer } from "@components/General/Containers"
import { H2Title, Subtitle } from "@components/General/Titles"
import designSystem from "@styles/designSystem"
import { NormalButton } from '@components/General/Button';
import { QontactLogoPanel } from '@components/QontactLogoPanel';
import { useQRScreenViewModel } from '../view-models/QRCodeScreenViewModel';
import { ReactComponent as PhoneMockupSVG } from '@assets/SVGs/PhoneMockup.svg'; // Adjust path as needed
import { ReactComponent as QontactTextSVG } from '@assets/SVGs/GeneralUse/Qontact.svg';
import { ReactComponent as QontactBackgroundSVG } from '@assets/SVGs/GeneralUse/QontactBackground.svg';
import { isMobile } from 'react-device-detect';
import { Title } from '@mui/icons-material';
import { SmallText } from '@components/General/Texts';
import { Text } from "@components/General/Texts"
interface QRModalScreenProps {
    qpID?: string
}

export const QRModalScreen: React.FC<QRModalScreenProps> = ({
        qpID
    }) => {

    const {
        qrCodeUrl,
        qpId,
        isLoading,
        handleAlreadyDone,
    } = useQRScreenViewModel(qpID);

    return (            
        <VerticalContainer 
            maxWidth={'100%'} 
            alignment={'center'}
        >
            <VerticalContainer paddingTop={designSystem.paddingLg}>
                <SmallText text={"Puedes escanear nuevamente el QR para registrar tu salida y ver cuánto tiempo has trabajado.".localized()}/>
            </VerticalContainer>
            <VerticalContainer width={'100%'} gap={designSystem.paddingSm}>
                {/* QR Code Display */}
                <HorizontalContainer 
                    width={'100%'}
                    justifyContent={'center'}
                >
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                    {isLoading ? (
                        <div style={{ 
                            width: '200px', 
                            height: '200px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: designSystem.colorBackgroundGray2,
                            borderRadius: '8px',
                        }}>
                            <p style={{ color: designSystem.colorWarningText }}>
                                {"Generando QR...".localized()}
                            </p>
                        </div>
                    ) : qrCodeUrl ? (
                        <img 
                            src={qrCodeUrl} 
                            alt="QR Code" 
                            style={{ 
                                width: '300px', 
                                height: '300px',
                                imageRendering: 'auto',
                            }}
                        />
                    ) : (
                        <div style={{ 
                            width: '300px', 
                            height: '300px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: designSystem.colorBackgroundGray2,
                            borderRadius: '8px',
                        }}>
                            <p style={{ color: designSystem.colorWarningText }}>
                                {"Error al generar QR".localized()}
                            </p>
                        </div>
                    )}
                </div>
                </HorizontalContainer>
                {qpId && (
                    <HorizontalContainer alignment={'center'} justifyContent={'center'}>
                        <SmallText text={"ID: "+qpID}/>
                    </HorizontalContainer>
                )}
            </VerticalContainer>
        </VerticalContainer>
    );
};